'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface ArticleTinjauDokumenCTAProps {
  postSlug: string;
}

export function ArticleTinjauDokumenCTA({ postSlug }: ArticleTinjauDokumenCTAProps) {
  const analytics = useAnalytics();

  const handleClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'tinjau-dokumen',
      ctaLabel: 'Analisis Dokumen Sekarang',
    });
  };

  return (
    <div className="not-prose my-12 bg-white border-2 border-black overflow-hidden md:max-w-[450px] md:mx-auto">
      <div className="p-6 md:p-8">
        <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 leading-tight uppercase font-sans tracking-tight">
          Dokumen Anda
          <br />
          Sudah Patuh?
        </h3>

        <p className="text-gray-700 font-medium mb-6">
          Tinjau Dokumen menganalisis kepatuhan, mendeteksi kontradiksi internal, dan mengidentifikasi klausa yang hilang dengan kutipan terverifikasi.
        </p>

        <Link
          href="/id/workspace/document-review"
          onClick={handleClick}
          className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-4 font-bold text-sm md:text-base border-2 border-black hover:bg-blue-700 transition-all hover:-translate-y-0.5"
        >
          Analisis Dokumen Sekarang
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
